import {Component, inject, OnInit} from '@angular/core';
import {HeaderComponent} from "../../../common/header/header.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {IonCol, IonContent, IonImg, IonRow} from "@ionic/angular/standalone";
import {RouterLink} from "@angular/router";
import {ContactFormComponent} from "../../contact/contact-form/contact-form.component";
import {LanguageService} from '../../../core/language.service';
import {formTypes, pages} from '../../../configs/config';

@Component({
    selector: 'app-asset-and-property',
    templateUrl: './asset-and-property.component.html',
    styleUrls: ['./asset-and-property.component.scss'],
    imports: [
        HeaderComponent,
        FooterComponent,
        IonContent,
        IonCol,
        IonImg,
        IonRow,
        ContactFormComponent
    ]
})
export class AssetAndPropertyComponent  implements OnInit {

  languageService: LanguageService = inject(LanguageService);
  formType = formTypes.b2b;
  assetProperty: any;
  constructor() { }

  async ngOnInit() {
    this.assetProperty = await this.languageService.loadContent(pages.assetsAndPropertyManagement);
  }

}
